module.exports = __webpack_public_path__ + "img/front-img.20ca09b2.png";